import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { KebabCasePipe } from "../../../pipes/kebab-case.pipe";
import { NgFor, SlicePipe } from "@angular/common";
import { RouterLink } from "@angular/router";
import { SkeletonImageComponent } from "../../skeleton-image/skeleton-image/skeleton-image.component";

@Component({
  selector: "app-noticia",
  templateUrl: "./noticia.component.html",
  styleUrls: ["./noticia.component.scss"],
  imports: [SkeletonImageComponent, RouterLink, SlicePipe, KebabCasePipe, NgFor],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoticiaComponent {
  @Input() noticia;
  @Input() idStart: any;
  @Input() size: number;

  formatDate(obj): any {
    if (obj == null) {
      return null;
    }
    return obj.toString().replace(/\s/g, "T");
  }

  trackByTag(index: number, tag: any): string | number {
    return tag?.idVideo || index;
  }
}
